import { CloudArrowDownIcon } from '@heroicons/react/24/outline';
import { createColumnHelper } from '@tanstack/react-table';
import { ICertificateReport } from 'types/domain/certificate';
import {  IOrgUserCertificate, IOrgUserCertificateReport } from 'types/domain/user';
import { convertDate } from 'utils/convertDate';

export const columns = () => {
  const columnHelper = createColumnHelper<ICertificateReport>();

  return [
    // columnHelper.accessor(row => !!row.certificates, {
    //   id: 'expand',
    //   cell: data => <Expander row={data.row} />,
    // }),
    columnHelper.accessor(row => row.name, {
      id: 'name',
      header: 'Name',
    }),
    columnHelper.accessor(row => row.total, {
      id: 'total',
      header: 'Total',
    }),

    // columnHelper.accessor(row => row.type, {
    //   id: 'type',
    //   header: 'Type',
    //   cell: data => GroupName(data.row.original.type),
    // }),
  ];
};

export const orgUserCertificateColumns = () => {
  const columnHelper = createColumnHelper<IOrgUserCertificateReport>();

  return [
    columnHelper.accessor(row => row.organisationUser.firstName, {
      id: 'name',
      header: 'Name',
      cell: data =>
        data.row.original.organisationUser
          ? data.row.original.organisationUser.firstName
            ? `${data.row.original.organisationUser.firstName} ${data.row.original.organisationUser.lastName}`
            : data.row.original.organisationUser.email || data.row.original.organisationUser.systemId || ''
          : '',
    }),
    columnHelper.accessor(row => row.created.date, {
      id: 'date',
      header: 'Date',
      cell: data => convertDate(data.row.original.created.date)?.toLocaleDateString(),
    }),
    columnHelper.accessor(row => row.url, {
      id: 'url',
      header: 'Download',
      cell: data => <LatestCertificate certificate={data.row.original} />,
    }),
  ];
};

export const LatestCertificate = ({ certificate }: { certificate: IOrgUserCertificate }) => {
  return certificate.url ? (
    <a className="flex items-center hover:underline" href={certificate.url} target={'_blank'} rel="noreferrer">
      <CloudArrowDownIcon className="inline-flex w-4 h-4 mr-2" />
      Download certificate
    </a>
  ) : null;
};
